import { render, staticRenderFns } from "./DateienInfos.vue?vue&type=template&id=3f9d0ed6&"
import script from "./DateienInfos.vue?vue&type=script&lang=js&"
export * from "./DateienInfos.vue?vue&type=script&lang=js&"
import style0 from "./DateienInfos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
